export default {
  ecommerceBannerData: {
    es: [
      {
        name: 'ecommerce',
        imageBanner: '',
        imageDesktopXL: '/assets/images/ecommerce/ecommerce-banner.webp',
        imageDesktop: '/assets/images/ecommerce/ecommerce-banner.webp',
        imageMobile: '/assets/images/ecommerce/ecommerce-banner.webp',
        altImage: 'Research ecommerce',
        text1: 'Research',
        text2: 'Ecommerce',
        text3: '',
        buttonText: '',
        buttonLink: '',
        buttonTarget: '',
      },
    ],
    en: [
      {
        name: 'ecommerce',
        imageBanner: '',
        imageDesktopXL: '/assets/images/ecommerce/ecommerce-banner.webp',
        imageDesktop: '/assets/images/ecommerce/ecommerce-banner.webp',
        imageMobile: '/assets/images/ecommerce/ecommerce-banner.webp',
        altImage: 'Research ecommerce',
        text1: '',
        text2: 'Research',
        text3: 'Ecommerce',
        buttonText: '',
        buttonLink: '',
        buttonTarget: '',
      },
    ],
  },
};
